import * as easyConnectionAPI from '../api/easyConnections';
import { getSelectedTicketShopNamesFromBrand } from '../selectors/tools';
import { INBOUND } from 'constants/messageDirection';
import get from 'lodash/get';
import * as parseUtil from 'util/parseSelectors';
import { easyConnectionFetched } from 'analytics/mlEventAnalytics';
import * as extract from 'extractFromState';
import * as types from 'actions/types';
import { handleError } from 'services/ErrorService/ErrorService';

export const getEasyConnectionData = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const selectedTicket = extract.extractSelectedTicketFromState(state);
    const customerName = extract.extractCustomerNameForSelectedTicket(state);
    const ticketId = selectedTicket && selectedTicket.ticketId;
    const firstMessage = extract.extractFirstMessage(state);
    const expertId = parseUtil.getExpertId();
    const incomingMessages = state.conversation.allMessages.filter(
      (messageId) => state.conversation[messageId].direction === INBOUND
    );
    const numCustomerMessagesOnLastRequest = get(
      state,
      `mlData.easyConnection[${ticketId}].numCustomerMessagesOnLastRequest`,
      0
    );
    const numberOfCustomerMessagesIncreased = incomingMessages.length > numCustomerMessagesOnLastRequest;

    if (firstMessage && selectedTicket && numberOfCustomerMessagesIncreased) {
      const { subject, simplrAccountObjectId, customerPtrId } = firstMessage;
      const customerEmail = selectedTicket.customerEmail;
      const shopNames = getSelectedTicketShopNamesFromBrand(state);
      const brand = extract.getBrandOfSelectedTicket(state);
      const message = incomingMessages.map((messageId) => state.conversation[messageId].messageBody);

      const result = await easyConnectionAPI.getEasyConnectionData({
        message,
        businessId: simplrAccountObjectId,
        customerId: customerPtrId,
        conversationId: ticketId,
        subject,
        shopNames,
        customerEmail,
        expertId,
        brand: brand ? [brand] : null,
        customerName,
      });

      const data = {
        customerName: get(result, 'data.customerName', []),
        connections: get(result, 'data.connections', []),
        toDisplay: get(result, 'data.toDisplay', false),
        numCustomerMessagesOnLastRequest: incomingMessages.length,
      };

      dispatch(setEasyConnectionData(data, ticketId));

      easyConnectionFetched({
        toDisplay: get(result, 'data.toDisplay'),
        customerName: get(result, 'data.customerName', []),
        requestDetails: get(result, 'data.requestDetails'),
        connections: get(result, 'data.connections'),
      });
    }
  } catch (error) {
    handleError({ error });
  }
};

const setEasyConnectionData = (data, ticketId) => ({
  type: types.SET_EASY_CONNECTION_DATA,
  data,
  ticketId,
});
